import { handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setCustomers, setCustomersPagination } from '../slices/customersSlice';
import { store } from '../store';

export const getCustomers = async ({
  loading,
  page,
  search,
  code,
  name,
  netsuite_customer_id,
  salesrep,
  credit_controller,
  phone,
} = {}) => {
  const res = await handleGetRequest(URI.customers, null, {
    toast: false,
    loading,
    params: {
      page,
      search,
      code,
      name,
      netsuite_customer_id,
      salesrep,
      credit_controller,
      phone,
    },
  });

  if (res?.ack) {
    store.dispatch(setCustomers(res.customers));
    store.dispatch(setCustomersPagination(res.pagination));
  }
  return res;
};

export const makeContact = async (body) => {
  const res = await handlePostRequest(URI.make_contact, body);
  return res;
};

export const assignUser = async ({ user_id, body }) => {
  const res = await handlePutRequest(URI.assign_user(user_id), body);
  if (res?.ack) getCustomers();
  return res;
};
